"use client"

import { DiscardedFieldDash } from "@/components/grading/discarded-field-dash"
import {
  PartialCompletionMark,
  PARTIAL_COMPLETION_SLOT_CLASS,
} from "@/components/grading/partial-completion-mark"
import { EVALUATION_NOT_STARTED_LABEL } from "@/lib/grading/copy"
import {
  GRADING_TABLE_SCORE_EARNED_STYLE,
  GRADING_TABLE_SCORE_PARTIAL_EARNED_STYLE,
} from "@/lib/grading/table-styles"
import { cn } from "@/lib/utils"
import {
  isEvaluationNotStarted,
  submissionQuestionCompletion,
  submissionTotals,
} from "@/lib/mock/exam-grading"
import type {
  AssessmentGradingState,
  GradingSubmission,
} from "@/lib/mock/exam-grading"

export function HubScoreCell({
  state,
  row,
}: {
  state: AssessmentGradingState
  row: GradingSubmission
}) {
  if (row.thrownOut) return <DiscardedFieldDash />

  if (isEvaluationNotStarted(row.scoreStatus)) {
    return (
      <span className="text-sm text-muted-foreground">
        {EVALUATION_NOT_STARTED_LABEL}
      </span>
    )
  }

  const totals = submissionTotals(state, row)
  const percent =
    totals.possible > 0
      ? Math.round((totals.earned / totals.possible) * 100)
      : 0
  const partial = row.scoreStatus === "Partially Evaluated"
  const completion = partial
    ? submissionQuestionCompletion(state, row)
    : null

  return (
    <span className="inline-flex items-center font-mono text-sm tabular-nums">
      <span
        className="font-semibold"
        style={
          partial
            ? GRADING_TABLE_SCORE_PARTIAL_EARNED_STYLE
            : GRADING_TABLE_SCORE_EARNED_STYLE
        }
      >
        {totals.earned}
      </span>
      <span className="font-normal text-muted-foreground">/{totals.possible}</span>
      <span className="font-normal text-muted-foreground"> ({percent}%)</span>
      <span
        className={cn(PARTIAL_COMPLETION_SLOT_CLASS, "ms-1")}
        aria-hidden={!partial}
      >
        {partial && completion ? (
          <PartialCompletionMark
            scoredCount={completion.scoredCount}
            totalCount={completion.totalCount}
          />
        ) : null}
      </span>
    </span>
  )
}
